import Vue from "vue";
import App from "./app.vue";
import "./scss/bootstrap-overrides.scss";
import "./scss/_nucleo-glyph.scss";
import "bootstrap";

Vue.config.productionTip = false;
var vueData = require("../mocks/ExxonMobil-content.json");

if (process.env.NODE_ENV == "development") {
  // this is enable the aemPreview
  vueData.sourceRequestApp = "INFOCUS_UI";
}
else {
  vueData.surveyHistory = {};
  // overrides these attributes with microsite's itemData values
  // this should match the parameters of the micrositeData handlebar
  vueData.preference = itemData.preference;
  vueData.transactionId = itemData.transactionId;
  vueData.additionalAttributes.cusipClassList = itemData.additionalAttributes.cusipClassList;
}

console.log(vueData.transactionId);

new Vue({
  provide: {
    contentData: vueData.additionalAttributes.aem.content,
    brandData: vueData.additionalAttributes.aem.brand,
    vueData,
  },
  render: (h) => h(App),
}).$mount("#app");
